import React from "react";
import Button from "../atoms/Button";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StyledParagraph = styled.p`
  margin-bottom: 0;
`;

const LoginExpiredModal = ({ message }) => {
  const { t } = useTranslation(["dossier"]);
  return (
    <>
      <p>{message}</p>
      <StyledParagraph>
        <Button wide primary onClick={() => location.reload()}>
          {t("dossier:expired_modal.stay")}
        </Button>
      </StyledParagraph>
    </>
  );
};

export default LoginExpiredModal;
